import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class PhotoService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  Getphoto():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Photo/GetDB`);
  }
  GetphotoPaged(data:any):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Photo/GetPagedDB`,data);
  }
  Deletephoto(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Photo/Delete?id=${id}`);
  }

  Createphoto(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Photo/Create`,data);
  }
  Updatephoto(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Photo/Update`,data)
  }
}
